export const Types = {
    LOGIN: 'USER_LOGIN',
    ADD_USER: 'ADD_USER',
    UPDATE_USER: 'UPDATE_USER',
    UPDATE_APP_DETAILS: 'UPDATE_APP_DETAILS',
    UPDATE_OFFERS: 'UPDATE_OFFERS',
    FAVOURITE_OFFER: 'FAVOURITE_OFFER',
    RESET_OFFERS: 'RESET_OFFERS',
    UPDATE_PROMPT: 'UPDATE_PROMPT',
    UPDATE_APP_VERSION: 'UPDATE_APP_VERSION'
}